import { createSelector } from '@reduxjs/toolkit';
import adapter from './adapter';

const getLoadingState = createSelector(
  (state) => state?.cart,
  (cart) => cart.loading,
);

const getAlert = createSelector(
  (state) => state.cart,
  (cart) => cart.alert,
);

/* What the cart comes to in money. Not to be confused with the adapter's own
   `selectTotal` below, which counts lines - the two are a letter apart and mean
   entirely different things, so anything counting lines reads
   `getCartItemCount` instead and neither name has to be guessed at. */
const getCartTotal = createSelector(
  (state) => state.cart,
  (cart) => cart.total,
);

const adapterSelectors = adapter.getSelectors((state) => state.cart);

const selectors = {
  getLoadingState,
  getAlert,
  getCartTotal,
  // How many lines are waiting in the cart - what the menu's badge counts.
  getCartItemCount: adapterSelectors.selectTotal,
  ...adapterSelectors,
};

export default selectors;
